import React, { useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  useMediaQuery,
  Typography,
  AppBar,
  Toolbar,
} from '@mui/material';
import { ChevronLeftOutlined, Menu } from '@mui/icons-material';
import { Navigate,  useNavigate } from 'react-router-dom';
import TopNav from '../v2/TopNav/TopNav';

const GlobalWrapper = ({
  children,
  SidebarComponent = null,
  sidebarProps = {},
  sidebarTitle = null,
  isPwa = false,
}) => {
  const navigate = useNavigate();

  const token = localStorage.getItem('token');
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };
  if (!token) {
    return <Navigate to='/' />;
  }
  return (
    <>
      {!isPwa && <TopNav />}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}>
        {SidebarComponent && isMobile && sidebarTitle && (
          <>
            <AppBar  position="sticky" color="default" elevation={1} sx={{ backgroundColor: 'white', zIndex: 100, boxShadow: 'none' }}>
              <Toolbar sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
                <ChevronLeftOutlined  onClick={() => navigate(-1)} />
                <Typography variant='h6' sx={{ color: 'black', fontWeight: 'bold' }}>{sidebarTitle}</Typography>
                <IconButton edge="end" onClick={toggleDrawer}><Menu /></IconButton>
              </Toolbar>
            </AppBar>
            <Drawer
              anchor='left'
              open={open}
              onClose={toggleDrawer}
            >
              <SidebarComponent {...sidebarProps} closeDrawer={toggleDrawer} />
            </Drawer>
          </>
        )}
        {SidebarComponent && !isMobile && (
          <>
            <Box sx={{ width: '18%', height: '100vh', overflowY: 'auto' }}>
              {SidebarComponent && <SidebarComponent {...sidebarProps} />}
            </Box>
          </>
        )}
        
        <Box
          sx={{
            width: isMobile || !SidebarComponent ? '100%' : '82%',
            height: '100vh',
            overflowY: 'auto',
            display: 'block'
          }}
        >
         {!isMobile && sidebarTitle && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                py: 2,
                px: 2,
              }}
            >
              <ChevronLeftOutlined onClick={() => navigate(-1)} fontSize={'large'}/>
              <Typography variant="h6" sx={{ color: 'black', fontWeight: 'bold', ml: 3 }}>
                {sidebarTitle}
              </Typography>
            </Box>
          )}
          
          {children}
        </Box>  
      </Box>
    </>
  );
};

export default GlobalWrapper;
